
 
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, pipe, throwError} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import decode from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../settings';
 
@Injectable({
  providedIn: 'root'
})
export class NewsletterService {

  private message: string; 

  constructor(private _router: Router,private http: HttpClient ) {

    
   }
   
  
   newsletterDataById(obj:any):any{ 
     
    try{
       
      
      let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
          })
        };

       
        let api_url =AppSettings.API_ENDPOINT+'newsletter.php';
    
        return this.http.post<any>(api_url,{'id':obj.id,'page':'newsletter','source':obj.source},httpOptions);


      }catch(err){
  
  
        // notify system api error 
        this._router.navigate(['/login']);
  
      }


  } 



  newsletterData(obj:any):any{ 
     
    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
          })
        };
       
        let api_url =AppSettings.API_ENDPOINT+'newsletter.php';
    
        return this.http.post<any>(api_url,obj.reqData,httpOptions);



      }catch(err){
  
  
        // notify system api error 
        this._router.navigate(['/login']);
  
      }


  } 

  newsletterList(obj:any):any{ 
     
    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
          })
        };
       
        let api_url =AppSettings.API_ENDPOINT+'newsletter.php';
    
        return this.http.post<any>(api_url,obj,httpOptions);



      }catch(err){
  
  
        // notify system api error 
        this._router.navigate(['/login']);
  
      }


  }

  imageUpload(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          "Authorization": "Bearer "+obj.token
          
        })
      };
     
      let api_url =AppSettings.API_ENDPOINT+'upload.php';
  
     return this.http.post<any>(api_url, obj.reqData,httpOptions);



    }catch(err){

      // notify system api error 
      this._router.navigate(['/login']);

    }

  }

  getUserList(obj:any):any{
    try{

      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          "Authorization": "Bearer "+obj.token, 
        })
      };

      let api_url =AppSettings.API_ENDPOINT+'user.php';

      return this.http.post<any>(api_url, obj,httpOptions);
    }
    catch(err)
    {
      this._router.navigate(['/login']);
    }  
  }



}